import React from 'react'
import Markets from '../components/Markets'


function CryptocurrenciesList() {

    document.title = "Markets | Lehumo";

    return (

        <>
            <br /><br />
            <Markets />
        </>
    )
}

export default CryptocurrenciesList